import * as Yup from "yup";
import { transformSnakeToCamel } from "utils/transform";
import { ERROR_MESSAGES } from "constants/validation";

/**
 * Campaign Schema
 * Represents a marketing campaign in the affiliate system
 * Base schema is loose to allow loading legacy data.
 */
export const CampaignSchema = Yup.object()
  .transform(transformSnakeToCamel)
  .shape({
    id: Yup.string().nullable(),
    name: Yup.string().nullable(),
    description: Yup.string().nullable(),
    condition: Yup.string().nullable(),
    bonusType: Yup.string().nullable(),
    bonusRate: Yup.number().default(0).nullable(), // Loose for loading
    bonusAmount: Yup.number().default(0).nullable(), // Loose for loading
    quotaType: Yup.string().nullable(),
    quotaLimit: Yup.number().default(0).nullable(), // Loose for loading
    quotaUsed: Yup.number().default(0).nullable(),
    startDate: Yup.date().nullable(),
    endDate: Yup.date().nullable(),
    status: Yup.string().nullable(),
    isActive: Yup.boolean().nullable(),
    // Timestamps
    updatedAt: Yup.date().nullable(),
    createdAt: Yup.date().nullable(),
  });

/**
 * Campaign Validation Schema
 * Strict rules applied only during form submission.
 */
export const CampaignValidationSchema = CampaignSchema.clone().shape({
  name: Yup.string().required(ERROR_MESSAGES.REQUIRED),
  condition: Yup.string().required(ERROR_MESSAGES.REQUIRED),
  bonusType: Yup.string().oneOf(["Percent", "Fixed"]).required(ERROR_MESSAGES.REQUIRED),
  quotaType: Yup.string().oneOf(["Unlimited", "Limited"]).required(ERROR_MESSAGES.REQUIRED),
  startDate: Yup.date().required(ERROR_MESSAGES.REQUIRED),
  endDate: Yup.date().required(ERROR_MESSAGES.REQUIRED),
  status: Yup.string().oneOf(["Active", "Inactive"]).required(ERROR_MESSAGES.REQUIRED),
  bonusRate: Yup.number()
    .min(0, ERROR_MESSAGES.BONUS_RATE_RANGE)
    .max(100, ERROR_MESSAGES.BONUS_RATE_RANGE)
    .default(0)
    .nullable(),
  bonusAmount: Yup.number()
    .min(0, ERROR_MESSAGES.BONUS_AMOUNT_MIN)
    .default(0)
    .nullable(),
  quotaLimit: Yup.number()
    .moreThan(0, ERROR_MESSAGES.QUOTA_LIMIT_POSITIVE)
    .integer(ERROR_MESSAGES.QUOTA_LIMIT_POSITIVE)
    .default(0)
    .nullable(),
});

export const CampaignMiniSchema = Yup.object()
  .transform(transformSnakeToCamel)
  .shape({
    id: Yup.string().nullable(),
    name: Yup.string().nullable(),
    description: Yup.string().nullable(),
    condition: Yup.string().nullable(),
    bonusType: Yup.string().nullable(),
    bonusRate: Yup.number().default(0).nullable(),
    bonusAmount: Yup.number().default(0).nullable(),
    startDate: Yup.date().nullable(),
    endDate: Yup.date().nullable(),
    status: Yup.string().nullable(),
    isActive: Yup.boolean().nullable(),
    // Timestamps
    updatedAt: Yup.date().nullable(),
    createdAt: Yup.date().nullable(),
  });
